/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import type { TdPopupProps } from './type';

export const popupDefaultProps: TdPopupProps = {
  destroyOnClose: false,
  hideEmptyPopup: false,
  placement: 'top',
  showArrow: false,
  trigger: 'hover',
};
